<template>
  <v-card class="elevation-2 rounded-lg my-5">
    <v-card-title class="py-4 primary--text text-center">
      <v-icon left color="primary">mdi-bell</v-icon>
      Notificaciones
    </v-card-title>

    <v-divider></v-divider>

    <v-form ref="notificationsForm" v-model="validationsNoti.isValid">
      <v-card-text class="pa-4">
        
        <!-- Notificaciones de movimiento existente -->
        <v-card class="mb-4 pa-3 rounded-lg" outlined>
          <h3 class="text-subtitle-1 font-weight-medium mb-2 text-center">
            <v-icon color="primary" left>mdi-swap-horizontal</v-icon>
            Notificaciones de movimiento
          </h3>
          <p class="grey--text text--darken-1 caption">Al crear una PETICIÓN MOVIMIENTO, quien recibe
            notificación para pasar de "SIN REPORTAR" a "REPORTADO"</p>

          <v-autocomplete 
            v-model="selectedResponsableMov" 
            :rules="validationsNoti.responsibleMov"
            multiple
            chips
            small-chips
            :error-messages="errorsNoti.responsableMov" 
            :items="userState.list" 
            :loading="userState.loading"
            :search-input.sync="userState.search2" 
            :disabled="loading" 
            :filter="filterUsers"
            :item-text="displayTextUser" 
            item-value="id" 
            label="Usuario Responsable"
            prepend-inner-icon="mdi-account-key" 
            hide-details="auto" 
            return-object 
            required 
            outlined 
            dense
            class="mt-2">
            <template v-slot:item="data">
              <v-list-item-avatar class="mr-2">
                <v-icon color="primary">mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.name} ${data.item.lastname}`"></v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ data.item.email }}</span>
                  <v-chip v-if="data.item._dealerName" x-small class="ml-2" color="primary" outlined>{{ data.item._dealerName }}</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:selection="data">
              <v-chip small close @click:close="removeResponsableMov(data.item)">
                <v-avatar left>
                  <v-icon small>mdi-account-circle</v-icon>
                </v-avatar>
                {{ data.item.name }} {{ data.item.lastname }}<span v-if="data.item._dealerName" class="ml-1 caption grey--text">({{ data.item._dealerName }})</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-card>

        <!-- NUEVA: Notificación de daños en 1era recepción - VEHÍCULO USADO -->
        <v-card class="mb-4 pa-3 rounded-lg" outlined>
          <h3 class="text-subtitle-1 font-weight-medium mb-2 text-center">
            <v-icon color="warning" left>mdi-alert-circle</v-icon>
            Notificación de daños - Vehículo USADO (1era recepción)
          </h3>
          <p class="grey--text text--darken-1 caption">Al hacer una 1era recepción y registrar DAÑOS en el vehículo usado, la notificación se envía al usuario que realiza la recepción y a:</p>

          <v-autocomplete 
            v-model="selectedDamageNotificationUsed" 
            :rules="validationsNoti.damageNotificationUsed"
            multiple
            chips
            small-chips
            :error-messages="errorsNoti.damageNotificationUsed" 
            :items="userState.list" 
            :loading="userState.loading"
            :search-input.sync="userState.search3" 
            :disabled="loading" 
            :filter="filterUsers"
            :item-text="displayTextUser" 
            item-value="id" 
            label="Usuario(s) a notificar sobre daños"
            prepend-inner-icon="mdi-account-alert" 
            hide-details="auto" 
            return-object 
            required 
            outlined 
            dense
            class="mt-2"
            hint="Se enviará la notificación por defecto al usuario responsable de daños">
            <template v-slot:item="data">
              <v-list-item-avatar class="mr-2">
                <v-icon color="warning">mdi-account-alert</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.name} ${data.item.lastname}`"></v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ data.item.email }}</span>
                  <v-chip v-if="data.item._dealerName" x-small class="ml-2" color="warning" outlined>{{ data.item._dealerName }}</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:selection="data">
              <v-chip small close @click:close="removeDamageNotificationUsed(data.item)" color="warning" text-color="white">
                <v-avatar left>
                  <v-icon small>mdi-account-alert</v-icon>
                </v-avatar>
                {{ data.item.name }} {{ data.item.lastname }}<span v-if="data.item._dealerName" class="ml-1 caption">({{ data.item._dealerName }})</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-card>

        <!-- NUEVA: Notificación de daños en 1era recepción - VEHÍCULO NUEVO -->
        <v-card class="mb-4 pa-3 rounded-lg" outlined>
          <h3 class="text-subtitle-1 font-weight-medium mb-2 text-center">
            <v-icon color="error" left>mdi-alert-octagon</v-icon>
            Notificación de daños - Vehículo NUEVO (1era recepción)
          </h3>
          <p class="grey--text text--darken-1 caption">Al hacer una 1era recepción con DAÑOS en el vehículo nuevo, la notificación se envía al usuario que realiza la recepción y a:</p>

          <v-autocomplete 
            v-model="selectedDamageNotificationNew" 
            :rules="validationsNoti.damageNotificationNew"
            multiple
            chips
            small-chips
            :error-messages="errorsNoti.damageNotificationNew" 
            :items="userState.list" 
            :loading="userState.loading"
            :search-input.sync="userState.search4" 
            :disabled="loading" 
            :filter="filterUsers"
            :item-text="displayTextUser" 
            item-value="id" 
            label="Usuario(s) a notificar sobre daños"
            prepend-inner-icon="mdi-account-alert" 
            hide-details="auto" 
            return-object 
            required 
            outlined 
            dense
            class="mt-2"
            hint="Se enviará la notificación por defecto al usuario responsable de daños">
            <template v-slot:item="data">
              <v-list-item-avatar class="mr-2">
                <v-icon color="error">mdi-account-alert</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.name} ${data.item.lastname}`"></v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ data.item.email }}</span>
                  <v-chip v-if="data.item._dealerName" x-small class="ml-2" color="error" outlined>{{ data.item._dealerName }}</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:selection="data">
              <v-chip small close @click:close="removeDamageNotificationNew(data.item)" color="error" text-color="white">
                <v-avatar left>
                  <v-icon small>mdi-account-alert</v-icon>
                </v-avatar>
                {{ data.item.name }} {{ data.item.lastname }}<span v-if="data.item._dealerName" class="ml-1 caption">({{ data.item._dealerName }})</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-card>

        <!-- NUEVA: Notificación de movimiento con daños -->
        <v-card class="mb-4 pa-3 rounded-lg" outlined>
          <h3 class="text-subtitle-1 font-weight-medium mb-2 text-center">
            <v-icon color="deep-orange" left>mdi-car-brake-alert</v-icon>
            Notificación de movimiento con DAÑOS
          </h3>
          <p class="grey--text text--darken-1 caption">Al hacer una entrega o recepción donde el vehículo tiene daños, se envía la notificación al usuario que realiza la acción y a:</p>

          <v-autocomplete 
            v-model="selectedMovementDamageNotification" 
            :rules="validationsNoti.movementDamageNotification"
            multiple
            chips
            small-chips
            :error-messages="errorsNoti.movementDamageNotification" 
            :items="userState.list" 
            :loading="userState.loading"
            :search-input.sync="userState.search5" 
            :disabled="loading" 
            :filter="filterUsers"
            :item-text="displayTextUser" 
            item-value="id" 
            label="Usuario(s) responsable de movimientos con daños"
            prepend-inner-icon="mdi-account-wrench" 
            hide-details="auto" 
            return-object 
            required 
            outlined 
            dense
            class="mt-2"
            hint="Se enviará la notificación por defecto al usuario responsable de movimientos con daños">
            <template v-slot:item="data">
              <v-list-item-avatar class="mr-2">
                <v-icon color="deep-orange">mdi-account-wrench</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.name} ${data.item.lastname}`"></v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ data.item.email }}</span>
                  <v-chip v-if="data.item._dealerName" x-small class="ml-2" color="deep-orange" outlined>{{ data.item._dealerName }}</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:selection="data">
              <v-chip small close @click:close="removeMovementDamageNotification(data.item)" color="deep-orange" text-color="white">
                <v-avatar left>
                  <v-icon small>mdi-account-wrench</v-icon>
                </v-avatar>
                {{ data.item.name }} {{ data.item.lastname }}<span v-if="data.item._dealerName" class="ml-1 caption">({{ data.item._dealerName }})</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-card>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="saving" :disabled="saving || !validationsNoti.isValid"
          @click="saveNotificationSettings">
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import UserService from '@/services/UserService'
import DealerService from '@/services/DealerService'
import PartnerGroupService from '@/services/PartnerGroupService'

export default {
  name: 'NotificationSettings',
  data() {
    return {
      loading: false,
      saving: false,
      selectedResponsableMov: [],
      selectedDamageNotificationUsed: [],
      selectedDamageNotificationNew: [],
      selectedMovementDamageNotification: [],
      
      userState: {
        list: [],
        loading: false,
        search2: '',
        search3: '',
        search4: '',
        search5: ''
      },

      fields: {
        newMovementResponsibleMail: null,
        damageNotificationUsedMail: [],
        damageNotificationNewMail: [],
        movementDamageNotificationMail: []
      },

      validationsNoti: {
        isValid: true,
        responsibleMov: [
          (v) => (v && v.length > 0) || 'Debe proporcionar al menos un responsable.'
        ],
        damageNotificationUsed: [
          // (v) => (v && v.length > 0) || 'Debe proporcionar al menos un responsable para notificaciones de daños.'
        ],
        damageNotificationNew: [
          // (v) => (v && v.length > 0) || 'Debe proporcionar al menos un responsable para notificaciones de daños.'
        ],
        movementDamageNotification: [
          // (v) => (v && v.length > 0) || 'Debe proporcionar al menos un responsable para movimientos con daños.'
        ]
      },

      errorsNoti: {
        responsableMov: [],
        damageNotificationUsed: [],
        damageNotificationNew: [],
        movementDamageNotification: []
      }
    }
  },

  watch: {
    selectedResponsableMov: function(newUsers) {
      this.fields.newMovementResponsibleMail = newUsers ? newUsers.map(user => user.email) : []
    },

    selectedDamageNotificationUsed: function(newUsers) {
      this.fields.damageNotificationUsedMail = newUsers ? newUsers.map(user => user.email) : []
    },

    selectedDamageNotificationNew: function(newUsers) {
      this.fields.damageNotificationNewMail = newUsers ? newUsers.map(user => user.email) : []
    },

    selectedMovementDamageNotification: function(newUsers) {
      this.fields.movementDamageNotificationMail = newUsers ? newUsers.map(user => user.email) : []
    }
  },

  async created() {
    await this.loadNotificationData()
    await this.loadResponsablesData()
  },

  methods: {
    async loadNotificationData() {
      try {
        const response = await UserService.getMe()
        const userData = response.data.data
        
        // Cargar configuraciones existentes
        this.fields.newMovementResponsibleMail = userData.dealer.config.newMovementResponsibleMail || []
        this.fields.damageNotificationUsedMail = userData.dealer.config.damageNotificationUsedMail || []
        this.fields.damageNotificationNewMail = userData.dealer.config.damageNotificationNewMail || []
        this.fields.movementDamageNotificationMail = userData.dealer.config.movementDamageNotificationMail || []
      } catch (error) {
        console.error('Error al cargar los datos de notificaciones:', error)
        this.$toast.error('Error al cargar la configuración de notificaciones')
      }
    },

    async loadResponsablesData() {
      try {
        this.userState.loading = true

        const isPartner = this.$store.getters.IS_PARTNER
        let allUsers = []

        if (isPartner) {
          // Para usuarios partner: cargar el grupo del partner y sus dealers (igual que PartnerGroupUsers.vue)
          const groupsResponse = await PartnerGroupService.index({ expand: 'dealerships' })
          const groups = groupsResponse.data.data || groupsResponse.data || []
          const groupsArray = Array.isArray(groups) ? groups : (groups.data || [])

          // Buscar TODOS los grupos que contienen el dealer del usuario actual
          const currentDealerId = this.$store.getters.CURRENT_USER?.dealer?.id

          const myGroups = groupsArray.filter(group =>
            (group.dealerships || []).some(d => d.id === currentDealerId)
          )

          // Recopilar todos los dealers únicos de todos los grupos encontrados
          const dealerIdsSeen = new Set()
          const dealerships = []
          for (const group of myGroups) {
            for (const d of (group.dealerships || [])) {
              if (!dealerIdsSeen.has(d.id)) {
                dealerships.push(d)
                dealerIdsSeen.add(d.id)
              }
            }
          }

          for (const dealer of dealerships) {
            try {
              const [usersResponse, managersResponse] = await Promise.all([
                UserService.getOnlyUsers({ 'filter[dealerId]': dealer.id, 'per-page': 200 }),
                UserService.getDealerManager(dealer.id)
              ])

              const dealerUsers = usersResponse.data.data || usersResponse.data || []
              const dealerManagers = managersResponse.data?.data?.data || []

              const existingIds = new Set(allUsers.map(u => u.id))
              dealerUsers.forEach(u => { if (!existingIds.has(u.id)) { allUsers.push({ ...u, _dealerName: dealer.name }); existingIds.add(u.id) } })
              dealerManagers.forEach(m => { if (m && !existingIds.has(m.id)) { allUsers.push({ ...m, _dealerName: dealer.name }); existingIds.add(m.id) } })
            } catch (dealerError) {
              console.error(`Error cargando usuarios del dealer ${dealer.name}:`, dealerError)
            }
          }
        } else {
          // Usuario normal: comportamiento original
          const [response, managerResp] = await Promise.all([
            UserService.get(),
            UserService.getMyManager()
          ])

          allUsers = response.data.data || []

          if (managerResp && managerResp.data && managerResp.data.data) {
            const mgrData = managerResp.data.data
            const mgrs = Array.isArray(mgrData) ? mgrData : [mgrData]
            mgrs.forEach(m => {
              if (m && !allUsers.some(u => u.id === m.id)) allUsers.unshift(m)
            })
          }
        }
        this.userState.list = allUsers

        // Mapear emails guardados a objetos de usuario
        const mapEmailsToUsers = (emails) => {
          const emailList = Array.isArray(emails) ? emails : [emails]
          const found = allUsers.filter(user => emailList.includes(user.email))
          return found
        }

        if (this.fields.newMovementResponsibleMail) {
          this.selectedResponsableMov = mapEmailsToUsers(this.fields.newMovementResponsibleMail)
        }
        if (this.fields.damageNotificationUsedMail) {
          this.selectedDamageNotificationUsed = mapEmailsToUsers(this.fields.damageNotificationUsedMail)
        }
        if (this.fields.damageNotificationNewMail) {
          this.selectedDamageNotificationNew = mapEmailsToUsers(this.fields.damageNotificationNewMail)
        }
        if (this.fields.movementDamageNotificationMail) {
          this.selectedMovementDamageNotification = mapEmailsToUsers(this.fields.movementDamageNotificationMail)
        }
      } catch (error) {
        console.error('[NotifSettings] Error al cargar los usuarios:', error)
        this.$toast.error('Error al cargar la lista de usuarios')
      } finally {
        this.userState.loading = false
      }
    },

    displayTextUser(item) {
      const dealer = item._dealerName ? ` [${item._dealerName}]` : ''
      return `${item.name} ${item.lastname}${dealer} - ${item.email}`
    },

    filterUsers(item, queryText, itemText) {
      const text = `${item.name} ${item.lastname} ${item.email}`.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.includes(searchText)
    },

    removeResponsableMov(item) {
      const index = this.selectedResponsableMov.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedResponsableMov.splice(index, 1)
      }
    },

    removeDamageNotificationUsed(item) {
      const index = this.selectedDamageNotificationUsed.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedDamageNotificationUsed.splice(index, 1)
      }
    },

    removeDamageNotificationNew(item) {
      const index = this.selectedDamageNotificationNew.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedDamageNotificationNew.splice(index, 1)
      }
    },

    removeMovementDamageNotification(item) {
      const index = this.selectedMovementDamageNotification.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedMovementDamageNotification.splice(index, 1)
      }
    },

    async saveNotificationSettings() {
      if (!this.validationsNoti.isValid) return

      this.saving = true
      try {
        const data = await UserService.getMe()
        const user = data.data.data
        
        const payload = {
          id: user.dealer.id,
          newMovementResponsibleMail: this.fields.newMovementResponsibleMail,
          damageNotificationUsedMail: this.fields.damageNotificationUsedMail,
          damageNotificationNewMail: this.fields.damageNotificationNewMail,
          movementDamageNotificationMail: this.fields.movementDamageNotificationMail
        }

        const response = await DealerService.putConfig(payload)

        if (response.data.success) {
          this.$toast.success('Configuración de notificaciones guardada con éxito')
          
          // Recargar después de un breve retraso
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        } else {
          this.$toast.error('Error al guardar la configuración de notificaciones')
        }
      } catch (error) {
        console.error('Error al guardar la configuración:', error)
        this.$toast.error('Ocurrió un error al guardar la configuración')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.v-chip {
  margin: 2px;
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
}
</style>
